import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ListChildComponentProps } from 'react-window';

import { LISTBOX_PADDING } from '@/shared/components/ui/form/components/searchable-select/components/list-box/list-box.constants';
import { SearchableSelectOption } from '@/shared/components/ui/form/components/searchable-select/components/option/searchable-select-option';

export const ListBoxRow = (props: ListChildComponentProps) => {
  const { t } = useTranslation();
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: (style.top as number) + index * 2,
  };

  const groupLabelMap: Record<string, string> = {
    selected: t('ui:selected'),
    unselected: t('ui:available'),
  };

  if (Object.hasOwn(dataSet, 'group')) {
    return (
      <Stack
        justifyContent="flex-start"
        style={{
          ...inlineStyle,
          top: (inlineStyle.top as number) + LISTBOX_PADDING,
        }}
      >
        <Typography key={dataSet.key} variant="h7" color="textSecondary">
          {groupLabelMap[dataSet.group]}
        </Typography>
      </Stack>
    );
  }

  const { key, ...optionProps } = dataSet[0];
  const renderLabel = dataSet[3];
  const option = dataSet[1];

  return (
    <SearchableSelectOption key={key} {...optionProps} style={inlineStyle}>
      {renderLabel(option)}
    </SearchableSelectOption>
  );
};
